import React, { useContext } from 'react';
import { Text } from '@custom-components';
import { Banner, envLookup } from './EnvBanner.styles';
import { UserCtx } from '../../contexts/UserCtx';
import { permission } from '../../containers/admin/Secure/permission';

function EnvBanner() {
  const userContext = useContext(UserCtx);

  // eslint-disable-next-line react/destructuring-assignment
  const productTeam = userContext.hasPermission(permission.view.productTeam);
  const env = envLookup[window.location.hostname.split('.')[0]];

  if (!productTeam || !env) return null;

  return (
    <Banner env={env}>
      <Text.CopyParagraph textTransform="uppercase" align="center" color="secondary" noMargins>
        {env}
      </Text.CopyParagraph>
    </Banner>
  );
}

export default EnvBanner;
